module.exports = __webpack_public_path__ + "static/media/mainPic.24c9487e.png";